import { Deserialize, IJsonObject } from 'dcerialize';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ReportConfig, ReportConfigList } from '../models/report-config';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { CustomSnackbarService } from './custom-snackbar.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor(
    protected http: HttpClient,
    private snackbarService: CustomSnackbarService,
    private apiService: ApiService
  ) {}

  get path(): string {
    return this.apiService.getApiUrl() + 'report';
  }

  /**
   * Get the Power BI configuration for a report, given its name
   */
  getConfig(reportName?: string): Observable<ReportConfig> {
    return this.http.get<IJsonObject>(`${this.path}/config/${reportName}`).pipe(
      map((reportConfig) => Deserialize(reportConfig, () => ReportConfig)),
      catchError((err: HttpErrorResponse) => this.snackbarService.showError(err))
    );
  }

  list(): Observable<ReportConfigList> {
    return this.http.get<IJsonObject>(`${this.path}`).pipe(
      map((reportConfigList) => Deserialize(reportConfigList, () => ReportConfigList)),
      catchError((err: HttpErrorResponse) => this.snackbarService.showError(err))
    );
  }
}
